import Component from './components/User';
import { PATH } from './constants';

export { PATH };
export default Component;
